import { render, staticRenderFns } from "./ParticipantPendingWidget.vue?vue&type=template&id=06fc675e"
import script from "./ParticipantPendingWidget.vue?vue&type=script&lang=js"
export * from "./ParticipantPendingWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports